import Vue from 'vue';
import Theme from '../../raccoonTheme';
export default Vue.extend({
    name: "MessageDialog",
    props: {
        title: {
            type: String,
            default: ''
        },
        texts: {
            type: Array,
            default: []
        },
        value: {
            type: Boolean,
            default: true
        },
        selectable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            model: "0",
            styles: {
                header: {
                    backgroundColor: Theme.primary,
                    width: '100%',
                    height: '64px',
                    position: 'relative'
                },
                title: {
                    fontSize: 'large',
                    textAlign: 'center'
                },
                text: {
                    fontSize: 'small',
                    color: Theme.textSlightGray
                },
            },
            visible: this.value
        };
    },
    methods: {
        getIndicatorStyle(isActive) {
            let style = {
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: Theme.primary,
                display: "inline",
                marginLeft: "8px",
                marginRight: "8px",
            };
            if (isActive) {
                style.backgroundColor = Theme.primary;
            }
            else {
                style.backgroundColor = Theme.textLightGray;
            }
            return style;
        },
        onClickedNegative() {
            this.$emit('input', false);
            this.$emit('cancel');
        },
        onClickedPositive() {
            this.$emit('input', false);
            this.$emit('close');
        }
    },
    watch: {
        visible() {
            this.$emit('input', this.$data.visible);
        },
        value() {
            this.visible = this.value;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/MessageDialog.vue
// module id = 394
// module chunks = 1